export default __webpack_public_path__ + "static/media/151-pincers.530cff3b.png";